<div
  #container
  ngDraggable
  [handle]="dragHandle"
  class="container flex column"
  [ngStyle]="{ width: vm.windowWidth, height: vm.windowHeight }"
>
  <div #dragHandle class="flex row space-between header">
    <div class="flex column justify-center">
      <h2>{{ vm.windowTitle }}</h2>
    </div>
    <div class="flex row justify-center window-buttons">
      <div
        *ngIf="vm.state === 'previewInProcess'"
        class="enlarge"
        (mousedown)="vm.openFullScreen(container)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="11px"
          height="10px"
          viewBox="0 0 12 12"
        >
          <path
            fill-rule="evenodd"
            fill="rgb(125, 143, 161)"
            d="M11.310,12.000 L6.995,12.000 L6.995,10.976 L10.975,10.976 L10.975,6.996 L11.999,6.996 L11.999,11.311 C11.999,11.691 11.690,12.000 11.310,12.000 ZM10.975,1.020 L6.995,1.020 L6.995,-0.004 L11.310,-0.004 C11.690,-0.004 11.999,0.305 11.999,0.684 L11.999,4.999 L10.975,4.999 L10.975,1.020 ZM-0.005,11.311 L-0.005,6.996 L1.019,6.996 L1.019,10.976 L4.999,10.976 L4.999,12.000 L0.683,12.000 C0.304,12.000 -0.005,11.691 -0.005,11.311 ZM1.019,4.999 L-0.005,4.999 L-0.005,0.684 C-0.005,0.305 0.304,-0.004 0.683,-0.004 L4.999,-0.004 L4.999,1.020 L1.019,1.020 L1.019,4.999 Z"
          ></path>
        </svg>
      </div>
      <evrideo-x-button
        (mousedown)="vm.closeWindow()"
        [overrideStyle]="{
          'margin-top': '-0.11vw',
          width: '1.15vw',
          height: '1.15vw'
        }"
      ></evrideo-x-button>
    </div>
  </div>
  <ng-container
    *ngIf="vm.state === 'previewInProcess' || vm.state == 'previewSetup'"
  >
    <div class="flex column body" *ngIf="vm.selectedShow">
      <ng-container *ngIf="vm.state === 'previewInProcess'">
        <div class="preview-video">
          <button [inlineSVG]="vm.getSvg()" (click)="vm.toggleSound()"></button>
          <video
            *ngIf="vm.channelPreviewData"
            autoplay
            width="100%"
            height="100%"
            [poster]="'/assets/stream-preview-loader.gif'"
            [webrtc-src]="vm.channelPreviewData"
            [muted]="vm.videoMute"
            (playing)="vm.onVideoPlaying($event)"
          ></video>
        </div>
      </ng-container>
      <ng-container *ngIf="vm.state === 'previewSetup'">
        <div class="flex row property" *ngIf="vm.showMediaIdField">
          <b>ID:</b>
          {{ vm.showMediaIdField && vm.selectedShow.tenantMediaUniqueId }}
        </div>
        <div class="flex row property">
          <b>Name:</b> {{ vm.selectedShow.name }}
        </div>
        <div class="flex row property">
          <b>Start Time:</b>{{ vm.formatTime(vm.selectedShow.startTime) }}
        </div>
        <div class="flex row property">
          <b>End Time:</b>{{ vm.formatTime(vm.selectedShow.endTime) }}
        </div>
        <div class="flex row property">
          <b>Duration:</b> {{ vm.selectedShow.duration.asSeconds() | duration }}
        </div>
        <div class="flex row property">
          <b>Play Preview for:</b>
          <icn-dropdown
            [placeholder]="'Select Preview Duration'"
            [(selectedValue)]="vm.selectedPreviewDuration"
          >
            <icn-dropdown-item
              *ngFor="let previewDuration of vm.allPreviewDurations"
              [title]="previewDuration.displayName"
              [value]="previewDuration"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
      </ng-container>
    </div>
    <div class="flex column justify-evenly footer" *ngIf="vm.selectedShow">
      <div class="flex row duration-slider">
        <evrideo-time-slider
          class="flex fill-width"
          [minMs]="0"
          [maxMs]="vm.selectedShow.duration.asMilliseconds()"
          [(valueMs)]="vm.selectedShow.startOfPreviewMs"
          (valueMsChange)="vm.refreshPreview()"
        ></evrideo-time-slider>
      </div>
      <div class="flex row action-buttons space-between">
        <div class="flex row">
          Time Code:
          <evrideo-time-editor
            [(valueMs)]="vm.selectedShow.startOfPreviewMs"
            [fontSize]="'14px'"
            [height]="'12px'"
            [minMs]="0"
            [maxMs]="vm.selectedShow.duration.asMilliseconds()"
            [fullMode]="false"
            (valueMsChange)="vm.refreshPreview()"
          ></evrideo-time-editor>
        </div>
        <div
          class="flex row"
          *ngIf="vm.state === 'previewInProcess' && vm.currentChannelTime"
        >
          Channel Time: {{ vm.formatTime(vm.currentChannelTime) }}
        </div>
        <div class="flex row">
          <evrideo-hover-button
            (click)="
              vm.state === 'previewInProcess'
                ? vm.refreshPreview()
                : vm.startPreviewing()
            "
          >
            <span class="start-btn">{{
              vm.state === "previewInProcess" ? "Refresh" : "Start"
            }}</span>
          </evrideo-hover-button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.state === 'previewEnded'">
    <div class="flex row fill-height justify-center">
      <div class="flex column justify-center fill-width preview-ended">
        <h1>Preview Ended</h1>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.state === 'limitExceeded'">
    <div class="flex row fill-height justify-center">
      <div class="flex column justify-center fill-width preview-ended">
        <h1>The tenant has exceeded the limit of the future previews</h1>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.state === 'unexpectedError'">
    <div class="flex row fill-height justify-center">
      <div class="flex column justify-center fill-width preview-ended">
        <h1>Unexpected error. Try again later.</h1>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.state === 'loading'">
    <div class="flex row fill-height justify-center">
      <div class="flex column justify-center">
        <h1>Loading...</h1>
      </div>
    </div>
  </ng-container>
</div>
